import { Component, ViewChild, NgZone } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ActionSheet, ActionSheetController, Config, ModalController,  PopoverController} from 'ionic-angular';
import { PbZonenData } from '../../../../providers/pbzonen-data';
import { UserData } from '../../../../providers/user-data';
import { MandantenData } from '../../../../providers/mandanten-data';
import { PbcatrulesComponent } from "../../../../components/pbcatrules/pbcatrules";
import { ToastController } from 'ionic-angular';
import { CommonData } from '../../../../providers/common-data';
import { CompletePPService } from '../../../../providers/epautocomplete-service';
import { ParplatzData } from '../../../../providers/pp-data';
import { GolinksData } from '../../../../providers/golinks-data';
import { PbKategorieSelection } from '../../pbkategorieselection/pbkategorieselection';
import { ParkbewilligungenData } from '../../parkbewilligungen-data';
import { CompleteZoneService } from '../../../../providers/zoneautocomplete-service';
@Component({
  selector: 'page-golinks-edit',
  templateUrl: 'golinks-edit.html',
})
export class GolinksEditPage {
  public golink: any;
  public physisch: number;
  public selectedkategorie;
  public selectedmandat;
  public customertab = "linkinfo";  
  public readonly: boolean = false;
  public fullurl: string;
  @ViewChild('parent') parent: any;

  constructor(
    public navCtrl: NavController
    , public navParams: NavParams
    , public userData: UserData
    , public mandantenData: MandantenData
    , public toastCtrl: ToastController
    , public common: CommonData
    , public zone: NgZone
    , public completePPService: CompletePPService
    , public ppData: ParplatzData
    , public pbData: ParkbewilligungenData
    , public pbZonenData: PbZonenData
    , public goData: GolinksData
    , public popoverCtrl: PopoverController
    , public completeZoneService: CompleteZoneService
    ) {
    this.physisch = 0;
    if(navParams.data.id>0){      
      this.prepareView(navParams.data.id);
             
    }
    else{
      //-- New pbzonen ------
      this.fullurl = "";
      this.golink = {active:1
                  
                  , mandate_mandid: this.userData.mandate_mandid
                  , attributes : {
                      edited:"created",
                      grundstuecke:[],
                      pbzonen:[],
                  }
                  
                };
      this.goData.generateURLIdent().then( (res) => {
        //console.log("generateURLIdent");
        //console.log(res);
        this.golink.urlident = res;
      });
      if(this.golink.mandate_mandid){
        this.selectedmandat = this.mandantenData.mandateby(this.golink.mandate_mandid);
      }
      else{
        this.selectedmandat = null;
      }      

      this.updateBestellURL();
    }

  }

  prepareView(id){
    this.goData.view(id).then(res => {
      //console.log(res);
      this.golink = res;

      this.fullurl = this.common.golink +this.golink.urlident;

      if(this.golink.attributes.physisch_name == "ja"){
        this.physisch = 1;
      }
      else{
        this.physisch = 0;
      }

      if(this.golink.attributes.pbkategorie_id){
        this.selectedkategorie = this.pbData.pbcategories.find(x => x.id === this.golink.attributes.pbkategorie_id);
      }
      else{
        this.selectedkategorie = null;
      }
      
      if(this.golink.mandate_mandid){
        //console.log("load selectedmandat")
        this.selectedmandat = this.mandantenData.mandateby(this.golink.mandate_mandid);
        //console.log(this.selectedmandat.length);
        //console.log(this.selectedmandat);
      }
      else{
        this.selectedmandat = null;
      }
      //console.log(this.pbzone);
      //this.updateBestellURL();    
      //this.oSelectedKategorieRegeln = res;
    });    

  }

  ionViewDidLoad() {
    //console.log(this.mandantenData.data);
  }

  validateInputs(){
    
    if (!this.golink.urlident || this.golink.urlident == ""){
      return -1;
    }
    if (!this.golink.mandate_mandid || this.golink.mandate_mandid<=0){
      return -2;
    }

    return 1;
  }

  pbzonenChange(event){
    //console.log(this.pbzone.edited);
    if(this.golink.attributes.edited != "created"){
      //console.log("changed");
      this.golink.attributes.edited = "changed";
    }
  }
  changeActive(event){
    if(this.golink.attributes.edited != "created"){
      this.golink.attributes.edited = "changed";
    }
  }

  rulesChanged(event){
    //console.log("rulesChanged");
    this.golink.attributes.edited = "changed";    
  }  

  showError(text: string){
    let toast = this.toastCtrl.create({
      message: text,
      position: 'top',
      cssClass: 'toast-error',
      duration: 3000
    });
    toast.present();         
  }
  showMessage(text: string){
    this.showError(text);
  }

  updateChanges(){

    switch(this.validateInputs()){
      case -1: this.showError('URL-Ident darf nicht leer sein.');
               return;
      case -2: this.showError('Mandat darf nicht leer sein.');
               return;

    }
    if(this.golink.attributes.edited =="changed"){
      this.goData.update(this.golink).then( (res:any) => {
        //console.log(res);
        if(!res.success){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          
          this.golink = res.data;               
          //this.updateBestellURL();          
          this.showError("Speichern erfolgreich");
      }
      });       
    }
    else if(this.golink.attributes.edited =="created"){
      //console.log("create kat");
      //console.log(this.golink);
      
      this.goData.create(this.golink).then(res => {
        //console.log(res);
        if(!res){
          this.showError("Fehler beim Speichern");
          return;
        }
        else{
          this.golink = res;     
          //this.updateBestellURL();
          this.prepareView(this.golink.id);
          this.showError("Golink erfolgreich gespeichert");


        }
      });      
    }
  }

  delete(){
    this.goData.delete(this.golink.id).then(res => {

      this.navCtrl.pop();
      //this.oSelectedKategorieRegeln = res;
    });    

  }

  discardChanges(){
    if(this.golink.attributes.edited =="created"){
      this.navCtrl.pop();      
    }
    else{
      this.prepareView(this.golink.id);
    }
    
  }

  changeMandat(event){
    this.selectedmandat = this.mandantenData.mandateby(event);

    this.golink.attributes.grundstuecke.length = 0;
    this.golink.attributes.pbzonen.length = 0;
    this.selectedkategorie = null;
    this.updateBestellURL();
  }
  updateBestellURL(){

    this.golink.url = this.common.pbappurl + "/bestellen2?m=" + this.golink.mandate_mandid;

    //-- Grundstuecke ------
    if(this.golink.attributes.grundstuecke && this.golink.attributes.grundstuecke.length>0){
      this.golink.url += "&g="+this.golink.attributes.grundstuecke.join();
    }
    //-- Zonen ------
    if(this.golink.attributes.pbzonen && this.golink.attributes.pbzonen.length>0){
      this.golink.url += "&z="+this.golink.attributes.pbzonen.join();
    }

    if(this.physisch == 1){
      this.golink.url += "&p=1";
    }

    if(this.selectedkategorie){
      this.golink.url += "&k="+this.selectedkategorie.id;
    }

    if(this.golink.attributes.edited != "created"){
      this.golink.attributes.edited = "changed";
    }

  }
  removePP(ppindex){
    this.golink.attributes.grundstuecke.splice(ppindex, 1); 
    this.updateBestellURL();

  }
  newPPSelected(event){
    let bpppresent = false;
    this.golink.attributes.grundstuecke.forEach((g,index) => {
      if(g == event.grundid){
        bpppresent = true;
      }
    });

    if(bpppresent){
      let toast = this.toastCtrl.create({
        message: "Parkplatz bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
    }
    else{
      if(event.fkmandat == this.golink.mandate_mandid){
        this.golink.attributes.grundstuecke.push(event.grundid);
        this.updateBestellURL();  
      }
      else{
        this.common.showError('Parkplatz gehört nicht zu ausgewähltem Mandat');
      }
    }    
  }  
  newZoneSelected(event){
    let bzonepresent = false;

    if(this.golink.attributes.pbzonen.length>0){
      let toast = this.toastCtrl.create({
        message: "Es kann nur eine Zone pro Link zugewiesen werden.",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });

      toast.present();         
      return;
    }
    

    this.golink.attributes.pbzonen.forEach((z,index) => {
      if(z == event.id){
        bzonepresent = true;
      }
    });

    if(bzonepresent){
      let toast = this.toastCtrl.create({
        message: "Zone bereits vorhanden",
        position: 'top',
        cssClass: 'toast-error',
        duration: 4000
      });

      toast.present();         
    }
    else{
      if(event.mandate_mandid == this.golink.mandate_mandid){
        this.golink.attributes.pbzonen.push(event.id);
        this.updateBestellURL();  
      }
      else{
        this.common.showError('Zone gehört nicht zu ausgewähltem Mandat');
      }
    }        

  }    
  removeZone(zoneindex){    
    this.golink.attributes.edited = "changed";
    this.golink.attributes.pbzonen.splice(zoneindex, 1);   
    this.updateBestellURL();
  }  


  showCategories(){

    let popover = this.popoverCtrl.create(PbKategorieSelection, {}, {cssClass: 'pbkatselection'});
    popover.onDidDismiss(async pbkat => {
      
      if(pbkat){
        if(pbkat.mandate_id == this.golink.mandate_mandid){
          this.selectedkategorie = pbkat;
          this.updateBestellURL();  
        }
        else{
          this.common.showError('Kategorie gehört nicht zu ausgewähltem Mandat');          
        }
      }
    });
    popover.present({
      ev: event
    });    

  }

  saveSVGAsImage(){
    //let qrcode = this.parent.nativeElement;
    //console.log(qrcode);
    //console.log(this.parent.el.nativeElement.childNodes[0]);
    var s = new XMLSerializer().serializeToString(this.parent.el.nativeElement.childNodes[0]);
    var encodedData = "data:image/svg+xml;base64," + window.btoa(s);
    

    // converts base 64 encoded image to blobData
    let blobData = this.convertBase64ToBlob(encodedData);

    // saves as image
    if (window.navigator && window.navigator.msSaveOrOpenBlob) { //IE
      window.navigator.msSaveOrOpenBlob(blobData, 'Qrcode');
    } else { // chrome
      const blob = new Blob([blobData], { type: "image/svg" });
      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'GoLink-'+this.golink.urlident+'-QR-Code.svg';
      link.click();
    }
  }

  private convertBase64ToBlob(Base64Image: any) {
    // SPLIT INTO TWO PARTS
    const parts = Base64Image.split(';base64,');
    // HOLD THE CONTENT TYPE
    const imageType = parts[0].split(':')[1];
    // DECODE BASE64 STRING
    const decodedData = window.atob(parts[1]);
    // CREATE UNIT8ARRAY OF SIZE SAME AS ROW DATA LENGTH
    const uInt8Array = new Uint8Array(decodedData.length);
    // INSERT ALL CHARACTER CODE INTO UINT8ARRAY
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i);
    }
    // RETURN BLOB IMAGE AFTER CONVERSION
    return new Blob([uInt8Array], { type: imageType });
  }

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/golinks/golinks-edit/golinks-edit.ts